import { Box, SimpleGrid, Text, Flex, Icon, Container } from "@chakra-ui/react";
import {
  FaUsers,
  FaChartLine,
  FaUserCheck,
  FaExchangeAlt,
  FaChartBar,
  FaMoneyBillWave,
} from "react-icons/fa";
import axios from "axios";
import { API_BASE } from "./config";
import { useEffect, useState } from "react";

function Dashboard() {
  const [users, setUsers] = useState<any>(0);
  const [tokens, setTokens] = useState<any>([]);

  const fetchUsers = async () => {
    try {
      const res = await axios.get(
        `${API_BASE}/api/admin/user/refferal?page=1&limit=10000`
      );
      setUsers(res?.data?.data?.length || []);
    } catch (err: any) {
      console.log("%c Line:24 🥃 err", "color:#b03734", err);
    } finally {
    }
  };
  const fetchTokens = async () => {
    try {
      const res = await axios.get(
        `${API_BASE}/api/admin/orders?page=1&limit=10000`
      );
      setTokens(res?.data?.data?.orders || []);
    } catch (err: any) {
      console.log("%c Line:39 🌭 err", "color:#7f2b82", err);
    } finally {
    }
  };
  // const fetchLeaderboard = async () => {
  //   setLoading(true);

  //   try {
  //     const res = await axios.get(
  //       `${API_BASE}/api/admin/leaderboard?page=1&limit=10000`
  //     );
  //     setLeaderboard(res?.data?.data?.leaderboards || []);
  //   } catch (err: any) {
  //     console.log("%c Line:53 🍖 err", "color:#fca650", err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  useEffect(() => {
    fetchUsers();
    // fetchLeaderboard();
  }, []);
  useEffect(() => {
    if (users) {
      console.log("Fetching tokens as users changed", users);
      fetchTokens();
    }
  }, [users]);
  const totalVolume = tokens?.reduce((acc: any, crr: any) => {
    return +acc + Number(crr?.sizeDeltaUsd) / 10 ** 30;
  }, 0);
  const avgVolumePerUser = (totalVolume / (users || 1))?.toFixed(2);
  const totalFees = (totalVolume * 0.01)?.toFixed(2);

  const statCards = [
    {
      label: "Total Wallet Connects",
      value: users || 0,
      icon: FaUsers,
      color: "blue.500",
      change: "+12%",
      isIncrease: true,
    },
    {
      label: "Active Wallets",
      value: users || 0,
      icon: FaUserCheck,
      color: "green.500",
      change: "+8%",
      isIncrease: true,
    },
    {
      label: "Total Trades",
      value: tokens?.length || 0,
      icon: FaExchangeAlt,
      color: "purple.500",
      change: "+24%",
      isIncrease: true,
    },
    {
      label: "Trading Volume",
      value: `$${totalVolume?.toFixed(2) || 0}`,
      icon: FaChartLine,
      color: "red.500",
      change: "+15%",
      isIncrease: true,
    },
    {
      label: "Avg Volume/User",
      value: `$${avgVolumePerUser}`,
      icon: FaChartBar,
      color: "orange.500",
      change: "-3%",
      isIncrease: false,
    },
    {
      label: "Fees Generated",
      value: `$${totalFees}`,
      icon: FaMoneyBillWave,
      color: "teal.500",
      change: "+18%",
      isIncrease: true,
    },
  ];

  return (
    <Container maxW="7xl" py={6}>
      {/* Header */}
      <Box mb={8}>
        <Text fontSize="3xl" fontWeight="700" color="white" mb={2}>
          Dashboard Overview
        </Text>
        <Text color="gray.400" fontSize="lg">
          Real-time analytics and key performance metrics
        </Text>
      </Box>

      {/* Stats Grid */}
      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
        {statCards.map((stat, index) => (
          <Box
            key={index}
            bg="gray.800"
            border="1px solid"
            borderColor="gray.700"
            borderRadius="12px"
            p={6}
            position="relative"
            overflow="hidden"
            _hover={{
              borderColor: "gray.600",
              transform: "translateY(-2px)",
              boxShadow: "xl",
            }}
            transition="all 0.2s ease-in-out"
          >
            {/* Gradient overlay */}
            <Box
              position="absolute"
              top={0}
              left={0}
              right={0}
              height="2px"
              bgGradient={`linear(to-r, ${stat.color}, ${stat.color.replace(
                ".500",
                ".300"
              )})`}
            />

            <Flex justify="space-between" align="start" mb={4}>
              <Box>
                <Icon as={stat.icon} w={8} h={8} color={stat.color} mb={3} />
                <Text
                  fontSize="sm"
                  fontWeight="500"
                  color="gray.400"
                  textTransform="uppercase"
                  letterSpacing="wide"
                >
                  {stat.label}
                </Text>
              </Box>
              <Box textAlign="right">
                <Flex
                  align="center"
                  color={stat.isIncrease ? "green.400" : "red.400"}
                >
                  <Text fontSize="sm" fontWeight="500">
                    {stat.isIncrease ? "↗" : "↘"} {stat.change}
                  </Text>
                </Flex>
              </Box>
            </Flex>

            <Text fontSize="2xl" fontWeight="700" color="white" lineHeight={1}>
              {typeof stat.value === "string"
                ? stat.value
                : stat.value.toLocaleString()}
            </Text>

            <Text fontSize="xs" color="gray.500" mt={1}>
              vs last month
            </Text>
          </Box>
        ))}
      </SimpleGrid>

      {/* Additional Info */}
      <Box
        mt={8}
        p={6}
        bg="gray.800"
        borderRadius="12px"
        border="1px solid"
        borderColor="gray.700"
      >
        <Flex align="center" justify="space-between">
          <Box>
            <Text fontSize="lg" fontWeight="600" color="white" mb={1}>
              System Status
            </Text>
            <Text color="gray.400" fontSize="sm">
              All systems operational
            </Text>
          </Box>
          <Box
            w={3}
            h={3}
            bg="green.400"
            borderRadius="full"
            boxShadow="0 0 10px rgba(72, 187, 120, 0.5)"
          />
        </Flex>
      </Box>
    </Container>
  );
}

export default Dashboard;
